var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-component-group"},[_c('div',{staticClass:"ui-component-group-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"ui-component-group-body"},[_c('div',{staticClass:"ui-component-group-line"}),_c('div',{staticClass:"ui-component-group-content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }